import { useEffect, useState } from "react";
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import { FaQuoteLeft } from "react-icons/fa6";

export default function HomeTestimonialPreview() {
  const [testimonials, setTestimonials] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchTestimonials = async () => {
      const q = query(
        collection(db, "testimonials"),
        where("active", "==", true),
        orderBy("order", "asc")
      );
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map(doc => doc.data());
      setTestimonials(data);
    };
    fetchTestimonials();
  }, []);

  if (!testimonials.length) return null;

  return (
    <section className="py-14 px-4 text-center bg-bg">
      <h2 className="text-2xl md:text-3xl font-extrabold mb-10 text-primary">
        {t("home.testimonialHeading")}
      </h2>
      <div className="max-w-2xl mx-auto">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          loop
          autoplay={{ delay: 5000 }}
          pagination={{ clickable: true }}
        >
          {testimonials.map((t, idx) => (
            <SwiperSlide key={idx}>
              <div className="bg-card rounded border border-mint/20 shadow p-8 flex flex-col items-center">
                <FaQuoteLeft className="text-mint text-3xl mb-3" />
                <p className="text-menu italic text-lg leading-relaxed mb-2">
                  “{t.quote?.[i18n.language] || t.quote?.vi}”
                </p>
                <div className="mt-1 text-base text-primary font-bold">
                  – {t.author}
                  {t.grade && <span className="text-sm text-text2 ml-1">({t.grade})</span>}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
